import React from 'react';
import { BsGrid1X2Fill, BsGrid } from 'react-icons/bs';
import Card from '~/Components/Card';
import { Content, Header, CardsContainer } from './styles';
import { COLORS } from '~/styles/colors';
import Footer from '~/Components/Footer';

function AcervoCartograficoMunicipal() {
	return (
		<>
			<Content>
				<Header>ACERVO CARTOGRÁFICO MUNICIPAL</Header>
				<p>Links úteis</p>
				<CardsContainer>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() => {
							window.open('http://www.prefeituradivinopolis.com.br/geoplantas/loteamentos/');
						}}
						icon={
							<BsGrid1X2Fill size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>LOTEAMENTOS</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() => {
							window.open('http://www.prefeituradivinopolis.com.br/geoplantas/planta_quadra/');
						}}
						icon={<BsGrid size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>PLANTAS DE QUADRA</span>
							</span>
						}
					/>
				</CardsContainer>
			</Content>
			<Footer />
		</>
	);
}

export default AcervoCartograficoMunicipal;
